/**
 * Tracks whether a critical field operation is in progress (Voice D.A.R.
 * recording/uploading, an active SOS flow, an in-progress patrol submission,
 * unsaved report data). Nothing in the app is ever interrupted because of this
 * flag — it only lets non-essential UI (such as the "new version available"
 * notice) stay out of the way until the operation finishes.
 */
const active = new Set<string>();
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

/** Mark a critical operation as running (`true`) or finished (`false`). */
export function setCriticalActivity(key: string, isActive: boolean): void {
  if (isActive) {
    if (active.has(key)) return;
    active.add(key);
  } else {
    if (!active.delete(key)) return;
  }
  emit();
}

export function isCriticalActivity(): boolean {
  return active.size > 0;
}

export function subscribeCriticalActivity(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
